const _excluded = ["children", "rtl", "className", "anchorUrlParameter"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './MultipleQuoteTestimonial.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import TestimonialQuote from '../51_TestimonialQuote/TestimonialQuote';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
export const MultipleQuoteTestimonial = _ref2 => {
  let {
    fields,
    params
  } = _ref2;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (!fields) {
    console.info('TestimonialQuote component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [TestimonialQuote component is empty: please provide data source]");
    }
    return null;
  }
  const quotes = [...get(fields, 'data.item.quotes.targetItems', []), ...get(fields, 'data.item.quoteTestimonials', [])];
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const ColorHex = get(fields, 'data.item.theme.targetItem.ColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const primaryColor = primaryPageThemeColor || getPageThemeColors(isVdsite).primary;
  const activeColor = ActiveColorHex || primaryActivePageThemeColor || getPageThemeColors(isVdsite).primary_active;
  const hasWhiteBG = BackgroundColorHex ? BackgroundColorHex.includes("#fff") : false;
  const renderItems = () => {
    return quotes.map((quote, i) => /*#__PURE__*/React.createElement(TestimonialQuote, {
      key: i,
      params: params,
      background: BackgroundColorHex || primaryPageThemeColor,
      color: BackgroundColorHex ? ColorHex : getColorByTheme(primaryColor),
      fields: {
        data: {
          item: quote
        }
      }
    }));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    style: {
      "--main-color--active": hasWhiteBG ? primaryActivePageThemeColor : activeColor,
      "--main-color": hasWhiteBG ? primaryPageThemeColor : BackgroundColorHex || primaryPageThemeColor
    },
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, _ref3 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref3;
    return /*#__PURE__*/React.createElement("div", {
      className: "row testimonial testimonial-multiple-quote",
      "data-cy": "testimonial-multiple-media"
    }, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      }
    }, () => tealiumClickFunc(tealiumMergeClickData({}, params))), /*#__PURE__*/React.createElement("div", {
      className: "testimonial__pagination"
    }, /*#__PURE__*/React.createElement("div", {
      className: `btn-group--right btn-group-arrows ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickData({}, params))), renderNextButton(() => tealiumClickFunc(tealiumMergeClickData({}, params)))), renderDots(() => tealiumClickFunc(tealiumMergeClickData({}, params)))));
  }));
};
const StyledWrapper = _ref => {
  let {
      children,
      rtl,
      className,
      anchorUrlParameter
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ComponentsWrapper, _extends({
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, otherProps), children);
};
export const commonStyles = "c1uyonf5";
export const ltrStyles = "l1nuc023";
export const rtlStyles = "r1n256d1";
export default MultipleQuoteTestimonial;